const FLAG_OFFSET = 127397;
const DISPLAY_COUNTRY_CODE_OVERRIDES = {
  TW: 'CN',
};

export const normalizeCountryCodeForDisplay = countryCode => {
  if (typeof countryCode !== 'string') {
    return '';
  }

  const normalizedCountryCode = countryCode.trim().toUpperCase();
  if (!normalizedCountryCode) {
    return '';
  }

  return (
    DISPLAY_COUNTRY_CODE_OVERRIDES[normalizedCountryCode] ||
    normalizedCountryCode
  );
};

/**
 * Gets emoji flag for given locale.
 *
 * @param {string} countryCode locale code
 * @return {string} emoji flag
 *
 * @example
 * getCountryFlag('cz') // '🇨🇿'
 */
export const getCountryFlag = countryCode => {
  const codePoints = normalizeCountryCodeForDisplay(countryCode)
    .toUpperCase()
    .split('')
    .map(char => FLAG_OFFSET + char.charCodeAt());

  return String.fromCodePoint(...codePoints);
};
